import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { inr } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Wallets() {
  const { user } = useAuth();
  const [rows, setRows] = useState(null);
  const multi = user.role !== "merchant";

  useEffect(() => {
    api.get("/wallets").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-heading text-2xl font-bold tracking-tight">Wallets</h2>
        <p className="text-sm text-muted-foreground">Settlement balances across the network.</p>
      </div>
      <Card className="p-4">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                {multi && <TableHead>Account</TableHead>}
                {multi && <TableHead>Role</TableHead>}
                <TableHead className="text-right">Earned</TableHead>
                <TableHead className="text-right">Locked</TableHead>
                <TableHead className="text-right">Paid out</TableHead>
                <TableHead className="text-right">Available</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows === null && <TableRow><TableCell colSpan={6} className="text-center py-8 text-muted-foreground">Loading…</TableCell></TableRow>}
              {rows && rows.length === 0 && <TableRow><TableCell colSpan={6} className="text-center py-8 text-muted-foreground">No wallets.</TableCell></TableRow>}
              {rows && rows.map((w) => (
                <TableRow key={w.user_id} data-testid={`wallet-row-${w.user_id}`}>
                  {multi && <TableCell><div className="font-medium text-sm">{w.business_name || w.name}</div><div className="text-xs text-muted-foreground">{w.email}</div></TableCell>}
                  {multi && <TableCell><Badge variant="outline" className="capitalize">{w.role}</Badge></TableCell>}
                  <TableCell className="text-right font-mono text-xs">{inr(w.earned)}</TableCell>
                  <TableCell className="text-right font-mono text-xs text-warning">{inr(w.locked)}</TableCell>
                  <TableCell className="text-right font-mono text-xs text-muted-foreground">{inr(w.paid)}</TableCell>
                  <TableCell className="text-right font-mono text-sm font-semibold text-success">{inr(w.available)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  );
}
